<template>
  <form-layout :label="label" :readonly="showReadonly">
    <switch-input :checked="checked" :readonly="true" />
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout';
import SwitchInput from '@/views/atoms/inputs/SwitchInput';

export default {
  name: "SwitchBrowseItem",
  props: {
    label: {
      type: String,
      required: true
    },
    checked: {
      type: [Boolean, null],
      required: true
    },
    showReadonly: {
      type: Boolean,
      default: false
    },
  },
  components: {
    FormLayout,
    SwitchInput,
  }
}
</script>
